export const MANAGE_WATCHER_TAB_TYPES = {
	PAGE: 0,
	SPACE: 1,
};

export const PAGINATE_BATCH_COUNT = 20;
